export default {"src":"/_next/static/image/public/assets/images/target.0409ea77ba0d090b5f2151723615d5c8.svg","height":16,"width":16};